
                import "css-modules://src_components_columns"
                export default {"Main":"_94eb90","Columns":"_418675"}
            